import {oldServerApi} from './RestService';
import {serverApi} from './RestService';
import {ImageFolder} from "../interfaces/response/ImageFolder";
import {UploadFoldersForImageRequest} from "../interfaces/request/UploadFoldersForImageRequest";
import {CsvFile} from "../interfaces/response/CsvFile";
import {UploadFilesForCsvRequest} from "../interfaces/request/UploadFilesForCsvRequest";
import {CreateCSVRequest} from "../interfaces/request/CreateCSVRequest";
import {GetTechnicalDetailsByEANRequest} from "../interfaces/request/GetTechnicalDetailsByEANRequest";
import {GetTechnicalDetailsByURLRequest} from "../interfaces/request/GetTechnicalDetailsByURLRequest";
import {TechnicalDetailsResponse} from "../interfaces/response/TechnicalDetailsResponse";
import { DeleteArticlesRequest } from "../interfaces/request/DeleteArticlesRequest";
import {DescriptionResponse} from "../interfaces/response/DescriptionResponse";
import {GetDescriptionByURLRequest} from "../interfaces/request/GetDescriptionByURLRequest";
import {ArticleDetails} from "../interfaces/response/ArticleDetails";


const articleService = oldServerApi.injectEndpoints({
    endpoints: builder => ({
        getAllCsvFiles: builder.query<CsvFile[], void>({
            query: () => 'csv/files'
        }),
        uploadCsvFiles: builder.mutation<string, UploadFilesForCsvRequest>(
            {
                query: (files) => ({
                    url: 'csv/upload',
                    method: 'POST',
                    body: files
                })
            }
        ),
        createCsvFile: builder.mutation<string, CreateCSVRequest>(
            {
                query: (content) => ({
                    url: 'csv/create',
                    method: 'POST',
                    body: content.content,
                    headers: {'SKU': content.code}
                })
            }
        ),
        getTechnicalDetailsByEAN: builder.mutation<TechnicalDetailsResponse, GetTechnicalDetailsByEANRequest>(
            {
                query: (request) => ({
                    url: 'details/technical/ean',
                    method: 'POST',
                    body: request,
                })
            }
        ),
        getTechnicalDetailsByURL: builder.mutation<TechnicalDetailsResponse, GetTechnicalDetailsByURLRequest>(
            {
                query: (request) => ({
                    url: 'details/technical/url',
                    method: 'POST',
                    body: request,
                })
            }
        ),
        getDescriptionByURL: builder.mutation<DescriptionResponse, GetDescriptionByURLRequest>(
            {
                query: (request) => ({
                    url: 'details/description/url',
                    method: 'POST',
                    body: request,
                })
            }
        )
    })
})

const articleServiceNew = serverApi.injectEndpoints({
    endpoints: builder => ({
        getAllImageFolders: builder.query<ImageFolder[], void>({
            query: () => 'microsoft/images/folders'
        }),
        uploadImageFolders: builder.mutation<string, UploadFoldersForImageRequest>(
            {
                query: (folders) => ({
                    url: 'microsoft/images/upload',
                    method: 'POST',
                    body: folders
                })
            }
        ),
        getArticleDetails: builder.query<ArticleDetails[], void>({
            query: () => '/articles'
        }),

        uploadArticleData: builder.mutation<ArticleDetails[], ArticleDetails>(
            {
                query: (content) => ({
                    url: 'article/upload',
                    method: 'POST',
                    body: content,
                })
            }
        ),
        refreshArticlesCache: builder.mutation<ArticleDetails[], void>({
            query: () => ({
                url: 'articles/refresh',
                method: 'GET'
            })
        }),
        getTechnicalDetails: builder.mutation<TechnicalDetailsResponse, GetTechnicalDetailsByURLRequest>(
            {
                query: (request) => ({
                    url: 'details/technical',
                    method: 'POST',
                    body: request,
                })
            }
        ),
        getDescription: builder.mutation<DescriptionResponse, GetDescriptionByURLRequest>(
            {
                query: (request) => ({
                    url: 'details/description',
                    method: 'POST',
                    body: request,
                })
            }
        ),
        deleteArticles: builder.mutation<string, DeleteArticlesRequest>(
            {
                query: (request) => {
                    const deleteRequest: DeleteArticlesRequest = {
                        skus: request.skus,
                        mode: request.mode,
                    };
                    return {
                        url: 'articles/delete',
                        method: 'POST',
                        body: deleteRequest,
                        // Backend returns plain text; avoid JSON parse errors so unwrap() resolves on 2xx
                        responseHandler: 'text' as const,
                    };
                }
            }
        ),
        getBackupArticle: builder.query<ArticleDetails, string>(
            {
                query: (sku) => `/articles/backup/${sku}`
            }
        ),
        checkBackupExists: builder.query<boolean, string>(
            {
                query: (sku) => `/articles/backup/${sku}/exists`
            }
        ),
        getBackupStorageStatus: builder.query<{available: boolean}, void>(
            {
                query: () => '/articles/backup/status'
            }
        )
    })
});

export const {  useGetAllCsvFilesQuery, useLazyGetAllCsvFilesQuery,
                useUploadCsvFilesMutation,
                useCreateCsvFileMutation,
                useGetTechnicalDetailsByEANMutation,
                useGetTechnicalDetailsByURLMutation,
                useGetDescriptionByURLMutation,

} = articleService

export const {  useUploadImageFoldersMutation,
                useGetAllImageFoldersQuery, useLazyGetAllImageFoldersQuery,
                useGetArticleDetailsQuery, useLazyGetArticleDetailsQuery,
                useUploadArticleDataMutation,
                useGetTechnicalDetailsMutation,
                useRefreshArticlesCacheMutation,
                useGetDescriptionMutation,
                useDeleteArticlesMutation,
                useGetBackupArticleQuery, useLazyGetBackupArticleQuery,
                useCheckBackupExistsQuery, useLazyCheckBackupExistsQuery,
                useGetBackupStorageStatusQuery, useLazyGetBackupStorageStatusQuery} = articleServiceNew;